
// Verhindere mehrfache Initialisierung
if (window.customProductBuilderInitialized) {
  console.warn("⚠️ Custom Product Builder bereits initialisiert - überspringe Duplikat");
} else {
  window.customProductBuilderInitialized = true;

document.addEventListener("DOMContentLoaded", function() {
  console.log("🚀 Custom Product Builder wird initialisiert");
  const allowedDiameters = [1.5,2.0,2.5,3.0,3.5,4,5,6,8,10,12];
  const allowedR = [8,11,17.5,25];
  const parseNum = v => parseFloat(v.replace(",",".").trim()) || 0;

  // ─── Ermittelt das gerade sichtbare Formular ────────────────────────────
  function getActiveContainer() {
    for (const cls of [
      'Planliegend-Rund',
      'Planliegend-Eckig',
      'Planliegend-Eckig-Rund',
      'Verdreht-Rund',
      'Verdreht-Eckig',
      'Verdreht-Eckig-Rund'
    ]) {
      const el = document.querySelector('.' + cls);
      if (el && el.offsetParent !== null) return el;
    }
    return null;
  }

  // ─── Pflichtfelder Firma, Name, E-Mail validieren ────────────────────────
  function validateExtras() {
    const fields = {
      firma: document.querySelector('textarea[placeholder="Firma"]'),
      name:  document.querySelector('textarea[placeholder="Vorname und Nachname"]'),
      email: document.querySelector('textarea[placeholder="E-Mail Adresse"]')
    };
    if (!fields.firma && !fields.name && !fields.email) return true;

    let warn = document.querySelector('.cpb-validate-warning--extras');
    if (!warn) {
      warn = document.createElement('div');
      warn.className = 'cpb-validate-warning--extras';
      warn.style.cssText = 'color:red;margin:10px 0;font-weight:bold;display:none';
      document.body.appendChild(warn);
    }

    const status = { firma: true, name: true, email: true };
    const errs   = [];

    if (fields.firma && !fields.firma.value.trim()) {
      status.firma = false;
      errs.push('Bitte Firma eingeben.');
    }
    if (fields.name && !fields.name.value.trim()) {
      status.name = false;
      errs.push('Bitte Vor- und Nachname eingeben.');
    }
    if (fields.email && !fields.email.value.trim()) {
      status.email = false;
      errs.push('Bitte E-Mail-Adresse eingeben.');
    }

    Object.entries(fields).forEach(([k,f]) => {
      if (!f) return;
      f.style.borderColor = status[k] ? 'green' : 'red';
    });

    if (errs.length) {
      warn.innerHTML = errs.map(e => '• ' + e).join('<br><br>');
      warn.style.display = 'block';
      return false;
    } else {
      warn.style.display = 'none';
      return true;
    }
  }

  // ─── Planliegend-Rund ───────────────────────────────────────────────────
  function validateRund(c) {
    const f = {
      length:   c.querySelector('textarea[placeholder="Länge (L in mm)"]'),
      diameter: c.querySelector('textarea[placeholder="Durchmesser (Ø in mm)"]'),
      d1:       c.querySelector('textarea[placeholder="D1"]'),
      d2:       c.querySelector('textarea[placeholder="D2"]'),
      w1:       c.querySelector('textarea[placeholder="W1"]'),
      w2:       c.querySelector('textarea[placeholder="W2"]'),
      r1:       c.querySelector('textarea[placeholder="R1"]'),
      r2:       c.querySelector('textarea[placeholder="R2"]')
    };
    if (!f.length || !f.diameter) return true;
    let warn = c.querySelector(".cpb-validate-warning");
    if (!warn) {
      warn = document.createElement("div");
      warn.className = "cpb-validate-warning";
      warn.style.cssText = "color:red;margin:10px 0;font-weight:bold;display:none";
      c.appendChild(warn);
    }
    const L  = parseNum(f.length.value),
          D  = parseNum(f.diameter.value),
          d1 = parseNum(f.d1.value),
          d2 = parseNum(f.d2.value),
          w1 = parseNum(f.w1.value),
          w2 = parseNum(f.w2.value),
          r1 = parseNum(f.r1.value),
          r2 = parseNum(f.r2.value);
    const status = { length:true, diameter:true, d1:true, d2:true, w1:true, w2:true, r1:true, r2:true };
    const errs = [];

    // Länge
    if (D>=1 && D<=4 && L<50)   { status.length=false; errs.push("Die Länge muss mindestens 50 mm betragen (bei Durchmesser 1–4 mm)."); }
    if (D>=5 && D<=8 && L<100)  { status.length=false; errs.push("Die Länge muss mindestens 100 mm betragen (bei Durchmesser 5–8 mm)."); }
    if (D>=10&& D<=12&& L<150)  { status.length=false; errs.push("Die Länge muss mindestens 150 mm betragen (bei Durchmesser 10–12 mm)."); }
    if (L>1500)                 { status.length=false; errs.push("Die Länge darf maximal 1500 mm betragen."); }

    // Ø
    if (!allowedDiameters.includes(D)) {
      status.diameter=false;
      errs.push("Der Durchmesser muss einem Lagerware-Wert entsprechen: " + allowedDiameters.join(" / ") + " mm.");
    }

    // D1/D2
    if (d1 < (r1*2)+D) { status.d1=false; errs.push("D1 muss mindestens R1 × 2 plus Durchmesser betragen."); }
    if (d2 < (r2*2)+D) { status.d2=false; errs.push("D2 muss mindestens R2 × 2 plus Durchmesser betragen."); }

    // W1/W2
    if (w1 < r1*2) { status.w1=false; errs.push("W1 muss mindestens R1 × 2 betragen."); }
    if (w2 < r2*2) { status.w2=false; errs.push("W2 muss mindestens R2 × 2 betragen."); }

    // R1/R2
    if (!allowedR.includes(r1)) { status.r1=false; errs.push("R1 muss einen der Werte 8 mm, 11 mm, 17,5 mm oder 25 mm haben."); }
    if (!allowedR.includes(r2)) { status.r2=false; errs.push("R2 muss einen der Werte 8 mm, 11 mm, 17,5 mm oder 25 mm haben."); }

    Object.keys(f).forEach(k => f[k].style.borderColor = status[k] ? "green" : "red");
    if (errs.length) {
      warn.innerHTML = errs.map(e => "• " + e).join("<br><br>");
      warn.style.display = "block";
      return false;
    }
    warn.style.display = "none";
    return true;
  }

  // ─── Planliegend-Eckig ─────────────────────────────────────────────────
  function validateEckig(c) {
    const f = {
      length:   c.querySelector('textarea[placeholder="Länge (L in mm)"]'),
      diameter: c.querySelector('textarea[placeholder="Durchmesser (Ø in mm)"]'),
      a1:       c.querySelector('textarea[placeholder="Winkel a1"]'),
      b1:       c.querySelector('textarea[placeholder="Winkel b1"]'),
      a2:       c.querySelector('textarea[placeholder="Winkel a2"]'),
      b2:       c.querySelector('textarea[placeholder="Winkel b2"]'),
      A:        c.querySelector('textarea[placeholder="Schenkel A"]'),
      B:        c.querySelector('textarea[placeholder="Schenkel B"]'),
      C:        c.querySelector('textarea[placeholder="Schenkel C"]'),
      Dv:       c.querySelector('textarea[placeholder="Schenkel D"]')
    };
    if (!f.length || !f.diameter) return true;
    let warn = c.querySelector(".cpb-validate-warning");
    if (!warn) {
      warn = document.createElement("div");
      warn.className = "cpb-validate-warning";
      warn.style.cssText = "color:red;margin:10px 0;font-weight:bold;display:none";
      c.appendChild(warn);
    }
    const L  = parseNum(f.length.value),
          D  = parseNum(f.diameter.value),
          a1 = parseNum(f.a1.value),
          b1 = parseNum(f.b1.value),
          a2 = parseNum(f.a2.value),
          b2 = parseNum(f.b2.value),
          A  = parseNum(f.A.value),
          B  = parseNum(f.B.value),
          C  = parseNum(f.C.value),
          D2 = parseNum(f.Dv.value);
    const status = { length:true, diameter:true, a1:true, b1:true, a2:true, b2:true, A:true, B:true, C:true, Dv:true };
    const errs = [];

    // Länge
    if (D>=1 && D<=4 && L<50)   { status.length=false; errs.push("Die Länge muss mindestens 50 mm betragen (bei Durchmesser 1–4 mm)."); }
    if (D>=5 && D<=8 && L<100)  { status.length=false; errs.push("Die Länge muss mindestens 100 mm betragen (bei Durchmesser 5–8 mm)."); }
    if (D>=10&& D<=12&& L<150)  { status.length=false; errs.push("Die Länge muss mindestens 150 mm betragen (bei Durchmesser 10–12 mm)."); }
    if (L>1500)                 { status.length=false; errs.push("Die Länge darf maximal 1500 mm betragen."); }

    // Ø
    if (!allowedDiameters.includes(D)) {
      status.diameter=false;
      errs.push("Der Durchmesser muss einem Lagerware-Wert entsprechen: " + allowedDiameters.join(" / ") + " mm.");
    }

    // Winkel
    if (a1 !== 135) { status.a1=false; errs.push("Der Winkel a1 muss 135° betragen."); }
    if (b1 !== 90)  { status.b1=false; errs.push("Der Winkel b1 muss 90° betragen."); }
    if (a2 !== 135) { status.a2=false; errs.push("Der Winkel a2 muss 135° betragen."); }
    if (b2 !== 90)  { status.b2=false; errs.push("Der Winkel b2 muss 90° betragen."); }

    // Schenkel A–D
    [["A",A],["B",B],["C",C],["D",D2]].forEach(([k,v])=>{
      let ok=true,msg="";
      if (D<4)       { ok=v>=8;   msg="8 mm"; }
      else if (D<=6) { ok=v>=22;  msg="22 mm"; }
      else if (D<=8) { ok=v>=24;  msg="24 mm"; }
      else if (D>=12){ ok=v>=32;  msg="32 mm"; }
      else if (D>=10){ ok=v>=30;  msg="30 mm"; }
      if (!ok) { status[k]=false; errs.push(`Der Schenkel ${k} muss mindestens ${msg} betragen.`); }
    });

    Object.keys(f).forEach(k => f[k].style.borderColor = status[k] ? "green" : "red");
    if (errs.length) {
      warn.innerHTML = errs.map(e => "• " + e).join("<br><br>");
      warn.style.display = "block";
      return false;
    }
    warn.style.display = "none";
    return true;
  }

  // ─── Planliegend-Eckig-Rund ────────────────────────────────────────────
  function validateEckigRund(c) {
    const f = {
      length:   c.querySelector('textarea[placeholder="Länge (L in mm)"]'),
      diameter: c.querySelector('textarea[placeholder="Durchmesser (Ø in mm)"]'),
      a1:       c.querySelector('textarea[placeholder="Winkel a1"]'),
      b1:       c.querySelector('textarea[placeholder="Winkel b1"]'),
      A:        c.querySelector('textarea[placeholder="Schenkel A"]'),
      B:        c.querySelector('textarea[placeholder="Schenkel B"]'),
      w1:       c.querySelector('textarea[placeholder="W1"]'),
      r1:       c.querySelector('textarea[placeholder="R1"]')
    };
    if (!f.length || !f.diameter) return true;
    let warn = c.querySelector(".cpb-validate-warning");
    if (!warn) {
      warn = document.createElement("div");
      warn.className = "cpb-validate-warning";
      warn.style.cssText = "color:red;margin:10px 0;font-weight:bold;display:none";
      c.appendChild(warn);
    }
    const L  = parseNum(f.length.value),
          D  = parseNum(f.diameter.value),
          a1 = parseNum(f.a1.value),
          b1 = parseNum(f.b1.value),
          A  = parseNum(f.A.value),
          B  = parseNum(f.B.value),
          w1 = parseNum(f.w1.value),
          r1 = parseNum(f.r1.value);
    const status = { length:true, diameter:true, a1:true, b1:true, A:true, B:true, w1:true, r1:true };
    const errs = [];

    // Länge
    if (D>=1 && D<=4 && L<50)   { status.length=false; errs.push("Die Länge muss mindestens 50 mm betragen (bei Durchmesser 1–4 mm)."); }
    if (D>=5 && D<=8 && L<100)  { status.length=false; errs.push("Die Länge muss mindestens 100 mm betragen (bei Durchmesser 5–8 mm)."); }
    if (D>=10&& D<=12&& L<150)  { status.length=false; errs.push("Die Länge muss mindestens 150 mm betragen (bei Durchmesser 10–12 mm)."); }
    if (L>1500)                 { status.length=false; errs.push("Die Länge darf maximal 1500 mm betragen."); }

    // Ø
    if (!allowedDiameters.includes(D)) {
      status.diameter=false;
      errs.push("Der Durchmesser muss einem Lagerware-Wert entsprechen: " + allowedDiameters.join(" / ") + " mm.");
    }

    // Winkel
    if (a1 !== 135) { status.a1=false; errs.push("Der Winkel a1 muss 135° betragen."); }
    if (b1 !== 90)  { status.b1=false; errs.push("Der Winkel b1 muss 90° betragen."); }

    // Schenkel A/B
    [["A",A],["B",B]].forEach(([k,v])=>{
      let ok=true,msg="";
      if (D<4)       { ok=v>=8;   msg="8 mm"; }
      else if (D<=6) { ok=v>=22;  msg="22 mm"; }
      else if (D<=8) { ok=v>=24;  msg="24 mm"; }
      else if (D>=12){ ok=v>=32;  msg="32 mm"; }
      else if (D>=10){ ok=v>=30;  msg="30 mm"; }
      if (!ok) { status[k]=false; errs.push(`Der Schenkel ${k} muss mindestens ${msg} betragen.`); }
    });

    // W1/R1
    if (w1 < r1*2) { status.w1=false; errs.push("W1 muss mindestens R1 × 2 betragen."); }
    if (!allowedR.includes(r1)) { status.r1=false; errs.push("R1 muss einen der Werte 8 mm, 11 mm, 17,5 mm oder 25 mm haben."); }

    Object.keys(f).forEach(k => f[k].style.borderColor = status[k] ? "green" : "red");
    if (errs.length) {
      warn.innerHTML = errs.map(e => "• " + e).join("<br><br>");
      warn.style.display = "block";
      return false;
    }
    warn.style.display = "none";
    return true;
  }

  

  // ─── Verdreht-Rund ─────────────────────────────────────────────────────
  function validateVerdrehtRund(c) {
    const f = {
      length:   c.querySelector('textarea[placeholder="Länge (L in mm)"]'),
      diameter: c.querySelector('textarea[placeholder="Durchmesser (Ø in mm)"]'),
      twist:    c.querySelector('textarea[placeholder="Verdrehung"]'),
      d1:       c.querySelector('textarea[placeholder="D1"]'),
      d2:       c.querySelector('textarea[placeholder="D2"]'),
      w1:       c.querySelector('textarea[placeholder="W1"]'),
      w2:       c.querySelector('textarea[placeholder="W2"]'),
      r1:       c.querySelector('textarea[placeholder="R1"]'),
      r2:       c.querySelector('textarea[placeholder="R2"]')
    };
    if(!f.length||!f.diameter) return true;
    let warn=c.querySelector(".cpb-validate-warning");
    if(!warn){
      warn=document.createElement("div");
      warn.className="cpb-validate-warning";
      warn.style.cssText="color:red;margin:10px 0;font-weight:bold;display:none";
      c.appendChild(warn);
    }
    const L = parseNum(f.length.value),
          D = parseNum(f.diameter.value),
          T = parseNum(f.twist.value),
          d1= parseNum(f.d1.value),
          d2= parseNum(f.d2.value),
          w1= parseNum(f.w1.value),
          w2= parseNum(f.w2.value),
          r1= parseNum(f.r1.value),
          r2= parseNum(f.r2.value);
    const status={length:true,diameter:true,twist:true,d1:true,d2:true,w1:true,w2:true,r1:true,r2:true};
    const errs=[];

    // Länge
    if (D>=1&&D<=4&&L<50)   { status.length=false; errs.push("Die Länge muss mindestens 50 mm betragen (bei Ø 1–4 mm)."); }
    if (D>=5&&D<=8&&L<100)  { status.length=false; errs.push("Die Länge muss mindestens 100 mm betragen (bei Ø 5–8 mm)."); }
    if (D>=10&&D<=12&&L<150){ status.length=false; errs.push("Die Länge muss mindestens 150 mm betragen (bei Ø 10–12 mm)."); }
    if (L>1500)             { status.length=false; errs.push("Die Länge darf maximal 1500 mm betragen."); }

    // Ø
    if (D<1||D>12||D===7)   { status.diameter=false; errs.push("Der Durchmesser muss zwischen 1 mm und 12 mm liegen (7 mm ausgeschlossen)."); }

    // Verdrehung
    if (![45,90,270].includes(T)) { status.twist=false; errs.push("Die Verdrehung muss 45°, 90° oder 270° betragen."); }

    // D1/D2
    if (d1<(r1*2)+D) { status.d1=false; errs.push("D1 muss mindestens R1 × 2 plus Durchmesser betragen."); }
    if (d2<(r2*2)+D) { status.d2=false; errs.push("D2 muss mindestens R2 × 2 plus Durchmesser betragen."); }

    // W1/W2
    if (w1<r1*2) { status.w1=false; errs.push("W1 muss mindestens R1 × 2 betragen."); }
    if (w2<r2*2) { status.w2=false; errs.push("W2 muss mindestens R2 × 2 betragen."); }

    // R1/R2
    if (!allowedR.includes(r1)) { status.r1=false; errs.push("R1 muss einen der Werte 8 mm, 11 mm, 17,5 mm oder 25 mm haben."); }
    if (!allowedR.includes(r2)) { status.r2=false; errs.push("R2 muss einen der Werte 8 mm, 11 mm, 17,5 mm oder 25 mm haben."); }

    Object.keys(f).forEach(k => f[k].style.borderColor = status[k] ? "green" : "red");
    if (errs.length) {
      warn.innerHTML = errs.map(e => "• " + e).join("<br><br>");
      warn.style.display = "block";
      return false;
    }
    warn.style.display = "none";
    return true;
  }

  // ─── Verdreht-Eckig ────────────────────────────────────────────────────
  function validateVerdrehtEckig(c) {
    const f = {
      length:   c.querySelector('textarea[placeholder="Länge (L in mm)"]'),
      diameter: c.querySelector('textarea[placeholder="Durchmesser (Ø in mm)"]'),
      twist:    c.querySelector('textarea[placeholder="Verdrehung"]'),
      a1:       c.querySelector('textarea[placeholder="Winkel a1"]'),
      a2:       c.querySelector('textarea[placeholder="Winkel a2"]'),
      b1:       c.querySelector('textarea[placeholder="Winkel b1"]'),
      b2:       c.querySelector('textarea[placeholder="Winkel b2"]'),
      A:        c.querySelector('textarea[placeholder="Schenkel A"]'),
      B:        c.querySelector('textarea[placeholder="Schenkel B"]'),
      C:        c.querySelector('textarea[placeholder="Schenkel C"]'),
      D:        c.querySelector('textarea[placeholder="Schenkel D"]')
    };
    if (!f.length || !f.diameter) return true;
    let warn = c.querySelector(".cpb-validate-warning");
    if (!warn) {
      warn = document.createElement("div");
      warn.className = "cpb-validate-warning";
      warn.style.cssText = "color:red;margin:10px 0;font-weight:bold;display:none";
      c.appendChild(warn);
    }
    const L  = parseNum(f.length.value),
          D  = parseNum(f.diameter.value),
          T  = parseNum(f.twist.value),
          a1 = parseNum(f.a1.value),
          a2 = parseNum(f.a2.value),
          b1 = parseNum(f.b1.value),
          b2 = parseNum(f.b2.value),
          A  = parseNum(f.A.value),
          B  = parseNum(f.B.value),
          C  = parseNum(f.C.value),
          D2 = parseNum(f.D.value);
    const status = { length:true, diameter:true, twist:true, a1:true, a2:true, b1:true, b2:true, A:true, B:true, C:true, D:true };
    const errs = [];

    // Länge
    if (D>=1&&D<=4&&L<50)   { status.length=false; errs.push("Die Länge muss mindestens 50 mm betragen (bei Durchmesser 1–4 mm)."); }
    if (D>=5&&D<=8&&L<100)  { status.length=false; errs.push("Die Länge muss mindestens 100 mm betragen (bei Durchmesser 5–8 mm)."); }
    if (D>=10&&D<=12&&L<150){ status.length=false; errs.push("Die Länge muss mindestens 150 mm betragen (bei Durchmesser 10–12 mm)."); }
    if (L>1500)             { status.length=false; errs.push("Die Länge darf maximal 1500 mm betragen."); }

    // Ø
    if (D<1||D>12||D===7)   { status.diameter=false; errs.push("Der Durchmesser muss zwischen 1 mm und 12 mm liegen (7 mm ausgeschlossen)."); }

    // Verdrehung
    if (![45,90,270].includes(T)) { status.twist=false; errs.push("Die Verdrehung muss 45°, 90° oder 270° betragen."); }

    // Winkel
    if (a1!==135) { status.a1=false; errs.push("Der Winkel a1 muss 135° betragen."); }
    if (a2!==135) { status.a2=false; errs.push("Der Winkel a2 muss 135° betragen."); }
    if (b1!==90)  { status.b1=false; errs.push("Der Winkel b1 muss 90° betragen."); }
    if (b2!==90)  { status.b2=false; errs.push("Der Winkel b2 muss 90° betragen."); }

    // Schenkel A–D
    [["A",A],["B",B],["C",C],["D",D2]].forEach(([k,v])=>{
      let ok=true,msg="";
      if (D<4)       { ok=v>=8;   msg="8 mm"; }
      else if (D<=6) { ok=v>=22;  msg="22 mm"; }
      else if (D<=8) { ok=v>=24;  msg="24 mm"; }
      else if (D>=12){ ok=v>=32;  msg="32 mm"; }
      else if (D>=10){ ok=v>=30;  msg="30 mm"; }
      if (!ok) { status[k]=false; errs.push(`Der Schenkel ${k} muss mindestens ${msg} betragen.`); }
    });

    Object.keys(f).forEach(k => f[k].style.borderColor = status[k] ? "green" : "red");
    if (errs.length) {
      warn.innerHTML = errs.map(e => "• " + e).join("<br><br>");
      warn.style.display = "block";
      return false;
    }
    warn.style.display = "none";
    return true;
  }

  // ─── Verdreht-Eckig-Rund ───────────────────────────────────────────────
  function validateVerdrehtEckigRund(c) {
    const f = {
      length:   c.querySelector('textarea[placeholder="Länge (L in mm)"]'),
      diameter: c.querySelector('textarea[placeholder="Durchmesser (Ø in mm)"]'),
      twist:    c.querySelector('textarea[placeholder="Verdrehung"]'),
      a1:       c.querySelector('textarea[placeholder="Winkel a1"]'),
      b1:       c.querySelector('textarea[placeholder="Winkel b1"]'),
      A:        c.querySelector('textarea[placeholder="Schenkel A"]'),
      B:        c.querySelector('textarea[placeholder="Schenkel B"]'),
      d1:       c.querySelector('textarea[placeholder="D1"]'),
      w1:       c.querySelector('textarea[placeholder="W1"]'),
      r1:       c.querySelector('textarea[placeholder="R1"]')
    };
    if (!f.length || !f.diameter) return true;
    let warn = c.querySelector(".cpb-validate-warning");
    if (!warn) {
      warn = document.createElement("div");
      warn.className = "cpb-validate-warning";
      warn.style.cssText = "color:red;margin:10px 0;font-weight:bold;display:none";
      c.appendChild(warn);
    }
    const L  = parseNum(f.length.value),
          D  = parseNum(f.diameter.value),
          T  = parseNum(f.twist.value),
          a1 = parseNum(f.a1.value),
          b1 = parseNum(f.b1.value),
          A  = parseNum(f.A.value),
          B  = parseNum(f.B.value),
          d1 = parseNum(f.d1.value),
          w1 = parseNum(f.w1.value),
          r1 = parseNum(f.r1.value);
    const status = { length:true, diameter:true, twist:true, a1:true, b1:true, A:true, B:true, d1:true, w1:true, r1:true };
    const errs = [];

    // Länge
    if (D>=1&&D<=4&&L<50)   { status.length=false; errs.push("Die Länge muss mindestens 50 mm betragen (bei Ø 1–4 mm)."); }
    if (D>=5&&D<=8&&L<100)  { status.length=false; errs.push("Die Länge muss mindestens 100 mm betragen (bei Ø 5–8 mm)."); }
    if (D>=10&&D<=12&&L<150){ status.length=false; errs.push("Die Länge muss mindestens 150 mm betragen (bei Ø 10–12 mm)."); }
    if (L>1500)             { status.length=false; errs.push("Die Länge darf maximal 1500 mm betragen."); }

    // Ø
    if (D<1||D>12||D===7)   { status.diameter=false; errs.push("Der Durchmesser muss zwischen 1 mm und 12 mm liegen (7 mm ausgeschlossen)."); }

    // Verdrehung
    if (![45,90,270].includes(T)) { status.twist=false; errs.push("Die Verdrehung muss 45°, 90° oder 270° betragen."); }

    // Winkel
    if (a1!==135) { status.a1=false; errs.push("Der Winkel a1 muss 135° betragen."); }
    if (b1!==90)  { status.b1=false; errs.push("Der Winkel b1 muss 90° betragen."); }

    // Schenkel A/B
    [["A",A],["B",B]].forEach(([k,v])=>{
      let ok=true,msg="";
      if (D<4)       { ok=v>=8;   msg="8 mm"; }
      else if (D<=6) { ok=v>=22;  msg="22 mm"; }
      else if (D<=8) { ok=v>=24;  msg="24 mm"; }
      else if (D>=12){ ok=v>=32;  msg="32 mm"; }
      else if (D>=10){ ok=v>=30;  msg="30 mm"; }
      if (!ok) { status[k]=false; errs.push(`Der Schenkel ${k} muss mindestens ${msg} betragen.`); }
    });

    // D1
    if (d1<(r1*2)+D) { status.d1=false; errs.push("D1 muss mindestens R1 × 2 plus Durchmesser betragen."); }
    // W1
    if (w1<r1*2)     { status.w1=false; errs.push("W1 muss mindestens R1 × 2 betragen."); }
    // R1
    if (!allowedR.includes(r1)) { status.r1=false; errs.push("R1 muss einen der Werte 8 mm, 11 mm, 17,5 mm oder 25 mm haben."); }

    Object.keys(f).forEach(k => f[k].style.borderColor = status[k] ? "green" : "red");
    if (errs.length) {
      warn.innerHTML = errs.map(e => "• " + e).join("<br><br>");
      warn.style.display = "block";
      return false;
    }
    warn.style.display = "none";
    return true;
  }

  
  

// ─── Delegation für Live-Input & Klick-Block ────────────────────────────
// Flag um mehrfache Anfragen zu verhindern
let isSubmitting = false;
let lastSubmitTime = 0;
const MIN_SUBMIT_INTERVAL = 3000; // Mindestens 3 Sekunden zwischen Anfragen

document.body.addEventListener("input", function(e) {
  if (e.target.tagName !== "TEXTAREA") return;
  const c = getActiveContainer();
  if (!c) return;

  if      (c.classList.contains("Planliegend-Rund"))       validateRund(c);
  else if (c.classList.contains("Planliegend-Eckig"))      validateEckig(c);
  else if (c.classList.contains("Planliegend-Eckig-Rund")) validateEckigRund(c);
  else if (c.classList.contains("Verdreht-Rund"))          validateVerdrehtRund(c);
  else if (c.classList.contains("Verdreht-Eckig"))         validateVerdrehtEckig(c);
  else if (c.classList.contains("Verdreht-Eckig-Rund"))    validateVerdrehtEckigRund(c);

  // Live-Validierung der Extras (Firma, Name, E-Mail)
  validateExtras();
});

document.body.addEventListener("click", function(e) {
  console.log("Klick auf Button");
  const btn = e.target.closest(".jetztAnfragenBtn");
  if (!btn) return;
  
  // ✋ Verhindere mehrfache Ausführungen
  if (isSubmitting) {
    console.log("⚠️ Anfrage läuft bereits - ignoriere weiteren Klick");
    e.stopPropagation();
    e.preventDefault();
    return;
  }
  
  // ✋ Prüfe zeitlichen Abstand zur letzten Anfrage
  const now = Date.now();
  if (lastSubmitTime && (now - lastSubmitTime) < MIN_SUBMIT_INTERVAL) {
    console.log("⚠️ Zu kurzer Abstand zur letzten Anfrage (" + Math.round((now - lastSubmitTime)/1000) + "s) - bitte warten");
    e.stopPropagation();
    e.preventDefault();
    alert("Bitte warten Sie mindestens " + (MIN_SUBMIT_INTERVAL/1000) + " Sekunden zwischen Anfragen.");
    return;
  }
  
  e.stopPropagation();      // ✋ verhindert doppelte Weitergabe
  e.preventDefault();       // falls Standard-Formularverhalten
  
  // Sofort Button deaktivieren und Flag setzen
  btn.disabled = true;
  isSubmitting = true;
  lastSubmitTime = now;
  
  const c = getActiveContainer();
  if (!c) {
    btn.disabled = false;
    isSubmitting = false;
    return;
  }


  // 1) Formular-spezifisch
  let ok = true;
  if      (c.classList.contains("Planliegend-Rund"))       ok = validateRund(c);
  else if (c.classList.contains("Planliegend-Eckig"))      ok = validateEckig(c);
  else if (c.classList.contains("Planliegend-Eckig-Rund")) ok = validateEckigRund(c);
  else if (c.classList.contains("Verdreht-Rund"))          ok = validateVerdrehtRund(c);
  else if (c.classList.contains("Verdreht-Eckig"))         ok = validateVerdrehtEckig(c);
  else if (c.classList.contains("Verdreht-Eckig-Rund"))    ok = validateVerdrehtEckigRund(c);

  // 2) Pflichtfelder Firma, Name & E-Mail
  if (!validateExtras()) ok = false;

  if (!ok) {
    // Bei Validierungsfehler: Button wieder aktivieren und Flag zurücksetzen
    btn.disabled = false;
    isSubmitting = false;
    
    e.preventDefault();
    e.stopImmediatePropagation();
    // zur ersten Fehlermeldung scrollen
    const firstWarn = document.querySelector('.cpb-validate-warning, .cpb-validate-warning--extras');
    firstWarn && firstWarn.scrollIntoView({ behavior: "smooth", block: "center" });
    return;
  }

      // 2) Payload bauen
    const payload = {};
    c.querySelectorAll("textarea").forEach(ta => {
      const key = ta.placeholder
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "_")
                    .replace(/^_|_$/g, "");
      payload[key] = ta.value.trim();
    });

// ─── 1) Aktive Bild-Optionen (type-img) ermitteln ──────────────────────
const imgOpts = Array.from(
  document.querySelectorAll('.cpb-option-type-img.cpb-active')
);

// ─── 2) Alt-Texte und Labels extrahieren ────────────────────────────────
const selected_alts = imgOpts
  .map(el => {
    const img = el.querySelector('img[alt]');
    return img ? img.alt.trim() : null;
  })
  .filter(Boolean);

const selected_labels = imgOpts
  .map(el => {
    const lbl = el.querySelector('.cpb-option-label');
    return lbl ? lbl.textContent.trim() : null;
  })
  .filter(Boolean);

// ─── Aktive Text-Optionen sammeln ───────────────────────────────────────
const textOpts = Array.from(
  document.querySelectorAll('.cpb-option-type-text.cpb-active')
);

const selected_texts = textOpts
  .map(el => el.textContent.trim())
  .filter(Boolean);


// ─── Firma auslesen ────────────────────────────────────────
const firmaField = document.querySelector('textarea[placeholder="Firma"]');
const firma  = firmaField ? firmaField.value.trim() : "";
    
// ─── Vorname und Nachname auslesen ────────────────────────────────────────
const nameField = document.querySelector('textarea[placeholder="Vorname und Nachname"]');
const fullName  = nameField ? nameField.value.trim() : "";


// ─── E-Mail auslesen ────────────────────────────────────────
const emailField = document.querySelector('textarea[placeholder="E-Mail Adresse"]');
const email      = emailField ? emailField.value.trim() : "";

// ─── Menge auslesen ───────────────────────────────────────────────────────
const mengeInput = document.querySelector('input[data-testid="counter-input"]');
const menge = mengeInput
  ? parseInt(mengeInput.value, 10) || 0
  : 0;


// ─── 3) Ins Payload packen ─────────────────────────────────────────────
payload.selected_alts   = selected_alts;
payload.selected_texts = selected_texts;
payload.menge = menge;  
payload.firma = firma;
payload.vorname_und_nachname = fullName;
payload.email_adresse = email;

// ─── 4) Debug-Log (optional) ────────────────────────────────────────────
console.log('DEBUG selected_alts:', selected_alts);
console.log('DEBUG selected_labels:', selected_labels);
console.log('DEBUG selected_texts:', selected_texts);
console.log('DEBUG email_adresse:', email);    


    

    // 3) jQuery-POST an dein n8n-Webhook
    const webhookUrl = "https://n8n.srv915020.hstgr.cloud/webhook/f120b577-4498-4520-89dc-0988c2bf3a63"; // <— deine URL
    
    console.log("📤 Sende Anfrage an n8n...");
    
   $.ajax({
  url: webhookUrl,
  method: "POST",
  contentType: "application/json; charset=UTF-8",
  dataType: "json",
  crossDomain: true,
  data: JSON.stringify(payload),
  success: function(resp, textStatus, xhr) {
    console.log("✅ Webhook OK:", xhr.status, resp);
    
    // Flag zurücksetzen nach erfolgreichem Senden
    isSubmitting = false;
    // Button bleibt disabled nach Erfolg
    
    let msg = c.querySelector(".cpb-success-msg");
    if (!msg) {
      msg = document.createElement("div");
      msg.className = "cpb-success-msg";
      msg.style.cssText = "color: green; margin: 10px 0; font-weight: bold;";
      c.appendChild(msg);
    }
    msg.textContent = "✅ Daten erfolgreich abgesendet!";
    msg.scrollIntoView({ behavior: "smooth", block: "center" });
  },
  error: function(xhr, textStatus, err) {
    console.error("❌ Webhook-Fehler:", textStatus, err, "Status:", xhr.status, "Response:", xhr.responseText);
    
    // Bei Fehler: Button wieder aktivieren und Flag zurücksetzen
    btn.disabled = false;
    isSubmitting = false;
    
    alert(
      "Fehler beim Absenden der Daten.\n" +
      "Status: " + xhr.status + "\n" +
      "Antwort: " + xhr.responseText + "\n" +
      "Siehe Console für Details."
    );
  }
});
 
  }, false);
});

} // Ende der Initialisierungs-Prüfung
